export const CONG_NO_LIST_INITING = 'CONG_NO_LIST_INITING'
export const CONG_NO_LIST_REQUESTING = 'CONG_NO_LIST_REQUESTING'
export const CONG_NO_LIST_SUCCESS = 'CONG_NO_LIST_SUCCESS'
export const CONG_NO_LIST_ERROR = 'CONG_NO_LIST_ERROR'

export const CONGNO_DVHC_LIST_REQUESTING = 'CONGNO_DVHC_LIST_REQUESTING'
export const CONGNO_DVHC_LIST_SUCCESS = 'CONGNO_DVHC_LIST_SUCCESS'
export const CONGNO_DVHC_LIST_ERROR = 'CONGNO_DVHC_LIST_ERROR'

export const CONG_NO_KHOXUAT_REQUESTING = 'CONG_NO_KHOXUAT_REQUESTING'
export const CONG_NO_KHOXUAT_SUCCESS = 'CONG_NO_KHOXUAT_SUCCESS'
export const CONG_NO_KHOXUAT_ERROR = 'CONG_NO_KHOXUAT_ERROR'

export const CONG_NO_EXPORT_XLS_REQUESTING = 'CONG_NO_EXPORT_XLS_REQUESTING'
export const CONG_NO_EXPORT_XLS_SUCCESS = 'CONG_NO_EXPORT_XLS_SUCCESS'
export const CONG_NO_EXPORT_XLS_ERROR = 'CONG_NO_EXPORT_XLS_ERROR'

export const CONG_NO_KH_LIST_REQUESTING = 'CONG_NO_KH_LIST_REQUESTING'
export const CONG_NO_KH_LIST_SUCCESS = 'CONG_NO_KH_LIST_SUCCESS'
export const CONG_NO_KH_LIST_ERROR = 'CONG_NO_KH_LIST_ERROR'

export const CONG_NO_KH_EXPORT_XLS_REQUESTING = 'CONG_NO_KH_EXPORT_XLS_REQUESTING'
export const CONG_NO_KH_EXPORT_XLS_SUCCESS = 'CONG_NO_KH_EXPORT_XLS_SUCCESS'
export const CONG_NO_KH_EXPORT_XLS_ERROR = 'CONG_NO_KH_EXPORT_XLS_ERROR'

export const CONG_NO_HD_LIST_REQUESTING = 'CONG_NO_HD_LIST_REQUESTING'
export const CONG_NO_HD_LIST_SUCCESS = 'CONG_NO_HD_LIST_SUCCESS'
export const CONG_NO_HD_LIST_ERROR = 'CONG_NO_HD_LIST_ERROR'

export const CONG_NO_HD_EXPORT_XLS_REQUESTING = 'CONG_NO_HD_EXPORT_XLS_REQUESTING'
export const CONG_NO_HD_EXPORT_XLS_SUCCESS = 'CONG_NO_HD_EXPORT_XLS_SUCCESS'
export const CONG_NO_HD_EXPORT_XLS_ERROR = 'CONG_NO_HD_EXPORT_XLS_ERROR'

export const CONG_NO_KHOXUAT_API = '/api/v1/kho/getKhoAllOfUser'
export const CONG_NO_LIST_API = '/api/v1/congno/congno_list_by_store'
export const CONG_NO_KH_LIST_API = '/api/v1/congno/congno_list_by_store_kh'
export const CONG_NO_HD_LIST_API = '/api/v1/congno/congno_list_by_store_hd'
export const CONG_NO_EXPORT_XLS_API = '/api/v1/congno/export_congno_list_by_store'
export const CONG_NO_KH_EXPORT_XLS_API = '/api/v1/congno/export_congno_list_by_store_kh'
export const CONG_NO_HD_EXPORT_XLS_API = '/api/v1/congno/export_congno_list_by_store_hd'
export const CONG_NO_DVHC_LIST_API = '/api/v1/management/dvhc_get_list' 


// WEBPACK FOOTER //
// ./src/views/CongNo/constants.js